import request from '@/api/request'

// 登录后台
export function loginCheck(params) {
	return request({ url: '/admin/loginCheck', method: 'post', data: params})
}

// 修改密码
export function changePsd(params) {
    return request({ url: '/admin/changePsd', method: 'post', data: params })
}

// 读取订单统计
export function statistic(params) {
    return request({ url: '/index/statistic', method: 'post', data: params })
}

export function getTimeOut(){
    return request({ url: '/admin/getTimeOut', method: 'get' })
}

export function setTimeOut(params){
    return request({ url: '/admin/setTimeOut', method: 'post', data: params  })
}